import React, { useContext } from "react";
import "./acerca.css";
import ImagePolygonItem from "../../ImagePolygon/ImagePolygonItem";
import { acerca, acercaEn } from "../../../json/nosotros/acerca";
import { LanguageContext } from "../../../context/LanguageContext/LanguageContext";
import { Parallax } from "react-scroll-parallax";

const useIsMobile = () => {
    const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);

    React.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return isMobile;
};

const Acerca = () => {
    const { language } = useContext(LanguageContext);
    const content = language === "ES" ? acerca : acercaEn;
    const isMobile = useIsMobile();

    const parallaxSpeed = isMobile ? -5 : -15;

    return (
        <div className="container-acerca">
            <div className="container">
                <div className="row">
                    {/* ------------------------------------------------- */}
                    {/* COLUMNA IZQUIERDA: TEXTO Y PARALLAX */}
                    {/* ------------------------------------------------- */}
                    <div className="col-md-6">
                        <div className="content-acerca">
                            <span>{content.subheading}</span>
                            <h1>{content.heading}</h1>
                            <p
                                dangerouslySetInnerHTML={{ __html: content.description }}
                            ></p>

                            <Parallax speed={parallaxSpeed}>
                                <div
                                    className="img-fondo"
                                    style={{
                                        backgroundImage: 'url("/assets/imgs/nosotros/acerca/fondo.png")',
                                    }}
                                ></div>
                            </Parallax>
                        </div>
                    </div>

                    {/* ------------------------------------------------- */}
                    {/* COLUMNA DERECHA: IMÁGENES POLIGONALES */}
                    {/* ------------------------------------------------- */}
                    <div className="col-md-6 content-images-acerca">
                        <div className="image-wrapper-acerca">
                            {content.images.map((image, index) => (
                                <ImagePolygonItem
                                    key={index}
                                    index={index}
                                    src={image.src}
                                    clipPath={image.clipPath}
                                    style={image.style}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Acerca;
